// extracted by css-extract-rspack-plugin
export default {"homepage":"homepage-zoi49p","iframe":"iframe-rlbZ1B"};